import useFlag from '../useFlag';
import { FeatureFlag } from 'constants-flags';

export function useWorkplaceOnboardingForMobileEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.WorkplaceOnboardingMobile,
    false
  );

  return Boolean(isEnabled);
}
